import { render, staticRenderFns } from "./aCardKpiIcon.vue?vue&type=template&id=0a252609"
import script from "./aCardKpiIcon.vue?vue&type=script&lang=js"
export * from "./aCardKpiIcon.vue?vue&type=script&lang=js"
import style0 from "./aCardKpiIcon.vue?vue&type=style&index=0&id=0a252609&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCardText,VCol,VIcon,VRow})
